import React from "react";
import { useNavigate } from "react-router-dom";
import "./QuickActions.css";

const QuickActions = ({ actions, onActionClick }) => {
  const navigate = useNavigate();

  const handleClick = (action) => {
    if (action.startsWith("/")) {
      navigate(action);
    } else if (onActionClick) {
      onActionClick(action);
    }
  };

  return (
    <div className="quick-actions">
      <div className="action-grid">
        {actions.map((action, idx) => (
          <div
            key={idx}
            className="action-card"
            onClick={() => handleClick(action.action)}
            style={{
              backgroundColor: `${action.color}15`,
              borderColor: `${action.color}30`,
            }}>
            <div className="action-icon" style={{ color: action.color }}>
              {action.icon}
              {action.badge > 0 && (
                <span className="action-badge">{action.badge}</span>
              )}
            </div>
            <span className="action-name">{action.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
